

<!--Autenticato: {{isLoggedIn ? 'SI' : 'NO'}} -->
<app-page>
    <h2 style="padding: 0.5rem !important;">Benvenuto <span class="font-medium">{{username()}}</span></h2>
    <app-dashboard-card></app-dashboard-card>
    <mat-divider></mat-divider>
    <br>
    <h2 style="padding: 0.5rem !important;text-align: center;margin-bottom: 0;">Punti Campionamento</h2>
    <div class="flex flex-column md:flex-row gap-3 w-full justify-content-around p-3">
        <div class="col-6">
            <app-page-list 
            [data]="data"
            [canShowBreadcrumb]="false"
            style="height: 50vh;"
            [columns]="columns" 
            [queryService]="service.query"
            [canInsert]="false" 
            [crud]="service" 
            [canSearch]="false" 
            [isRowClickable]="false"
            [insertForm]="insertForm"
            insertFormTitle="punto di campionamento"
            insertFormSize="full" 
            [visibleColumns]="visibleColumns"
            [customClickFunction]="customClickFunction"
            >
            </app-page-list>
        </div>
        <div class="col-6">
            <app-dashboard-map></app-dashboard-map>
        </div>

    </div>

</app-page>
